import React, { useState } from 'react';
import { string, object, func, bool, number, any, oneOfType } from 'prop-types';
import KEY_BINDINGS from 'constants/keyBindings.js';

const TabItem = ({
  name,
  value,
  active,
  onClick,
  tabIndex = 0,
  dataTestId,
  style: overwriteStyles = {},
  hoverStyle = {},
  activeStyle = {},
  ...restProps
}) => {
  const [hover, setHover] = useState(false);
  const [focus, setFocus] = useState(false);

  const handleMouseEnter = () => setHover(true);
  const handleMouseLeave = () => setHover(false);
  const handleBlur = () => setFocus(false);

  const handleTab = ({ key }) => {
    if (key === KEY_BINDINGS.ENTER || !key) {
      onClick(value);
    }
    if (key === KEY_BINDINGS.TAB) {
      setFocus(true);
    }
  };

  return (
    <li>
      <button
        className={focus ? 'has-focus-outline': ''}
        onClick={handleTab}
        onKeyUp={handleTab}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
        onBlur={handleBlur}
        role="tab"
        tabIndex={tabIndex}
        aria-selected={active}
        style={{
          ...styles.tab,
          ...overwriteStyles,
          ...(hover && {
            ...styles.hover,
            ...hoverStyle,
          }),
          ...(active && {
            ...styles.tabActive,
            ...activeStyle,
          }),
        }}
        data-test-id={dataTestId}
        {...restProps}
      >
        {name}
      </button>
    </li>
  );
};

const styles = {
  tab: {
    fontFamily: 'Haas Grot',
    background: 'none',
    border: '0',
    borderBottom: '0',
    fontSize: '14px',
    lineHeight: '18px',
    cursor: 'pointer',
    padding: '0 0 2px 0',
    marginRight: '24px',
    color: '#9F9F9F',
    fontWeight: '500',
  },
  hover: {
    color: '#000',
  },
  tabActive: {
    borderBottom: '2px solid #000',
    color: '#000',
  },
};

TabItem.propTypes = {
  name: string.isRequired,
  value: oneOfType([string, number, bool]).isRequired,
  active: bool,
  onClick: func,
  tabIndex: number,
  dataTestId: string,
  style: object,
  hoverStyle: object,
  activeStyle: object,
  restProps: any,
};

export default TabItem;
